import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useTrackingContext } from "#app/TrackingProvider.tsx";
import type { MixpanelEvent } from "#types/tracking.ts";
import { createTrackingFunction } from "@workleap/mixpanel";
import { useCallback } from "react";

export const useTracking = () => {
    const { navigationApiBaseUrl } = useEnvironmentVariables();
    const { trackingAppIdentifier, trackingSource } = useTrackingContext();

    const trackEvent = useCallback((eventName: MixpanelEvent, eventProperties: Record<string, unknown>) => {
        const _track = createTrackingFunction("wai", navigationApiBaseUrl, {
            targetProductId: trackingAppIdentifier
        });

        _track(eventName, { ...eventProperties, Source: trackingSource });
    }, [navigationApiBaseUrl, trackingAppIdentifier, trackingSource]);

    return { trackEvent };
};
